import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'managePages',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'managePagesApi',
  baseQuery,
  tagTypes: ['ManagePages'],
  endpoints: builder => ({
    getPages: builder.query({
      query: () => ({
        url: endpoints.PAGES,
        method: 'GET',
      }),
      providesTags: ['ManagePages'],
    }),
    getPageById: builder.query({
      query: id => ({
        url: endpoints.PAGES + '/' + id,
        method: 'GET',
      }),
    }),
    createPage: builder.mutation({
      query: data => ({
        url: endpoints.PAGES + '/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ManagePages'],
    }),
    updatePage: builder.mutation({
      query: data => ({
        url: endpoints.PAGES + '/update/' + data.id,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['ManagePages'],
    }),
    deletePage: builder.mutation({
      query: id => ({
        url: endpoints.PAGES + '/delete/' + id,
        method: 'DELETE',
      }),
      invalidatesTags: ['ManagePages'],
    }),
  }),
});

export const { actions: FilesActions } = slice;

export const usePagesSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: FilesActions,
    useGetPagesQuery: api.useLazyGetPagesQuery,
    useGetPageByIdQuery: api.useLazyGetPageByIdQuery,
    useCreatePageMutation: api.useCreatePageMutation,
    useUpdatePageMutation: api.useUpdatePageMutation,
    useDeletePageMutation: api.useDeletePageMutation,
  };
};
